import React, { useEffect, useRef, useState } from 'react';
import { Checkbox, message } from 'antd';
import logo from '../../assets/images/IE_logo.png';
import html2pdf from 'html2pdf.js';
import Button from 'components/Button/Button';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { getSessionToken } from 'utils/session';
import signature from '../../assets/images/principale_officer_signature.png';
import { toast, ToastContainer } from 'react-toastify';
import { dotPulse } from 'ldrs';
dotPulse.register();
const QuestionRadio = ({ name, question, value, handleChange }) => {
  return (
    <div
      className={`flex justify-between text-slate-700 ${
        name === 'question3' ? 'mt-2' : name === 'question14' ? 'mt-5' : 'mt-3'
      } `}
    >
      <label className="mb-2">{question}</label>
      <div className="flex items-center space-x-4">
        <div
          className={`cursor-pointer w-4 h-4 flex items-center justify-center rounded-full border-2 ${
            value === 'yes'
              ? 'bg-blue-700 border-slate-400'
              : 'bg-white border-slate-400'
          } transition-all`}
          onClick={() => handleChange(name, 'yes')}
        >
          {value === 'yes' && (
            <div className="w-3 h-3 bg-blue-700 rounded-full"></div>
          )}
        </div>
        <span className={`text-${value === 'yes' ? 'blue-500' : 'slate-700'}`}>
          Yes
        </span>

        <div
          className={`cursor-pointer w-4 h-4 flex items-center justify-center rounded-full border-2 ${
            value === 'no'
              ? 'bg-blue-700 border-slate-400'
              : 'bg-white border-slate-400'
          } transition-all`}
          onClick={() => handleChange(name, 'no')}
        >
          {value === 'no' && (
            <div className="w-3 h-3 bg-blue-700 rounded-full"></div>
          )}
        </div>
        <span className={`text-${value === 'no' ? 'blue-500' : 'slate-700'}`}>
          No
        </span>
      </div>
    </div>
  );
};

const Questions = ({ answers, setAnswers }) => {
  // Handler function to update the state when a radio button is selected
  const handleChange = (name, value) => {
    setAnswers((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <div id="agreement-content" className="flex flex-col w-full h-full">
      <QuestionRadio
        name="question1"
        question=" Have you ever registered or obtained a licence from any of the
            regulatory authorities under any law such as SEBI, RBI, IRDA, PFRDA,
            FMC etc. Any licence obtained from IRDA to work as an agent or POS
            of any insurance company or insurance intermediary is still in force
            or valid?"
        value={answers.question1}
        handleChange={handleChange}
      />

      <QuestionRadio
        name="question2"
        question="Have you carried on business under any name other than the name
            stated in this application{' '}"
        value={answers.question2}
        handleChange={handleChange}
      />
      <QuestionRadio
        name="question3"
        question="Have you ever been refused or restricted by any regulatory authority
            to carry on any business, trade or profession for which a specific
            licence registration or other authorization is required by law."
        value={answers.question3}
        handleChange={handleChange}
      />

      <QuestionRadio
        name="question4"
        question="Have you been ever censured or disciplined or suspended or refused
            permission or licence or registration by any regulatory authority to
            carry on any business activity"
        value={answers.question4}
        handleChange={handleChange}
      />

      <QuestionRadio
        name="question5"
        question="Have you been subject to any investigations or disciplinary
            proceeding or have been issued warning or reprimand by any
            regulatory authority"
        value={answers.question5}
        handleChange={handleChange}
      />

      <QuestionRadio
        name="question6"
        question="Have you been convicted of any offence or subject to any pending
            proceedings under any lawy"
        value={answers.question6}
        handleChange={handleChange}
      />

      <QuestionRadio
        name="question7"
        question=" Have you been banned from entry at any profession / occupation at
            any time."
        value={answers.question7}
        handleChange={handleChange}
      />

      <QuestionRadio
        name="question8"
        question="Details of prosecution, if any, pending or commenced or resulting in
            conviction in the past for violation of economic laws and
            regulations"
        value={answers.question8}
        handleChange={handleChange}
      />
      <QuestionRadio
        name="question9"
        question="Details of criminal prosecution, if any, pending or commenced or
            resulting in conviction in the past against you"
        value={answers.question9}
        handleChange={handleChange}
      />

      <QuestionRadio
        name="question10"
        question="Do you attract any of the disqualifications envisaged under Section
            164 of the Companies’ Act 2013?"
        value={answers.question10}
        handleChange={handleChange}
      />
      <QuestionRadio
        name="question11"
        question="Have you been subject to any investigation at the instance of a
            Government department or agency?"
        value={answers.question11}
        handleChange={handleChange}
      />

      <QuestionRadio
        name="question12"
        question=" Have you at any time been found guilty of violation of rules /
            regulations / legislative requirements by customs / excise / income
            tax / foreign exchange / other revenue authorities, if so give
            particulars"
        value={answers.question12}
        handleChange={handleChange}
      />

      <QuestionRadio
        name="question13"
        question=" Have you at any time been found guilty of violation of rules /
            regulations / legislative requirements by customs / excise / income
            tax / foreign exchange / other revenue authorities, if so give
            particulars"
        value={answers.question13}
        handleChange={handleChange}
      />
      <QuestionRadio
        name="question14"
        question=" Have you at any time come to the adverse notice of a regulator such
            as SEBI, IRDA, DCA (Though it shall not be necessary for a candidate
            to mention in the column about orders and findings made by
            regulators which have been later on reversed / set aside in to, it
            would be necessary to make a mention of the same, in case the
            reversal / setting aside is on technical reasons like limitation or
            lack of jurisdiction, etc, and not on merit. If the order of the
            regulator is temporarily stayed and the appellate / court
            proceedings are pending, the same also should be mentioned)."
        value={answers.question14}
        handleChange={handleChange}
      />
      <QuestionRadio
        name="question15"
        question=" Has any of your group company/associate company/related party been
            carrying any licence issued by the IRDA"
        value={answers.question15}
        handleChange={handleChange}
      />
    </div>
  );
};

const AgreementPage = () => {
  const agreementRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [answers, setAnswers] = useState({
    question1: 'no',
    question2: 'no',
    question3: 'no',
    question4: 'no',
    question5: 'no',
    question6: 'no',
    question7: 'no',
    question8: 'no',
    question9: 'no',
    question10: 'no',
    question11: 'no',
    question12: 'no',
    question13: 'no',
    question14: 'no',
    question15: 'no',
  });
  const [userData, setUserData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  const GetUserData = async () => {
    setDataLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/pos/pos_agreement/`,
        {
          params: { id: id },
        }
      );

      const data = response.data;

      if (data.is_submit) {
        navigate(`/posp/training/submited-agreement`, {
          state: { url: data.url, date: data.submited_on },
        });
      } else {
        setUserData(data.details);
      }
    } catch (error) {
      if (error.response.status == 500) {
        navigate(`/posp/error404`);
      }
      console.error('Error fetching user data:', error);
    }
    setDataLoading(false);
  };

  const PostUserData = async (pdfBlob) => {
    try {
      const formData = new FormData();
      formData.append('id', id); // Include ID
      formData.append('pdf', pdfBlob, 'generated-pdf.pdf');

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/pos/pos_agreement/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data', // Required for binary data
          },
        }
      );

      toast.success(`${response.data.message}`, {
        position: 'top-right', // Set the position of the toast
        autoClose: 3000, // Auto-close after 3 seconds
      });
      window.location.reload();
      // navigate(`/posp/training/submited-agreement`, { state: { url: data.url, date: data.submited_on } });
      // setLoading(false)
    } catch (error) {
      toast.error(
        'Error posting user data:',
        error.response?.data || error.message,
        {
          position: 'top-right', // Set the position of the toast
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  };

  useEffect(() => {
    GetUserData();
  }, []);
  // Function to generate a multi-page PDF
  const handleGeneratePDF = () => {
    setLoading(true);
    const element = document.getElementById('agreement-content');

    // Set options for html2pdf
    const options = {
      filename: 'generated-pdf.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        logging: true,
        scrollY: 0,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight * 2,
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      margin: [10, 10, 10, 10],
      pagebreak: { mode: 'auto' },
    };

    html2pdf()
      .from(element)
      .set(options)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();
        const pageWidth = pdf.internal.pageSize.getWidth();
        const logoWidth = 32;
        const xPos = pageWidth - logoWidth - 10;

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.addImage(logo, 'PNG', xPos, 3, logoWidth, 6);
        }

        // Convert PDF to Blob
        const pdfBlob = pdf.output('blob');

        // Call API with generated PDF
        PostUserData(pdfBlob);
      })
      .catch((error) => {
        console.error('Error generating PDF:', error);
        setLoading(false);
      });
  };

  // Function to Post PDF as Binary

  return dataLoading ? (
    <div className="flex justify-center items-center h-screen bg-white">
      <div className="flex items-center space-x-2 text-gray-700 text-lg ">
        <span className="text-3xl text-bold text-slate-600">Loading</span>
        <l-dot-pulse size="35" speed="1.3" color="gray"></l-dot-pulse>
      </div>
    </div>
  ) : (
    <div className="flex flex-col items-center justify-center p-6 bg-gray-100 min-h-screen">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Agreement Container */}
      <div
        id="agreement-content"
        ref={agreementRef}
        className="bg-white p-6 rounded-lg shadow-lg w-full max-w-5xl h-full overflow-y-scroll"
        style={{ maxHeight: '80vh' }} // Make the container scrollable
      >
        <h1 className="text-xl font-bold text-center mb-10 underline">
          Agreement of Appointment and Engagement for Point of Sale
        </h1>
        <h1 className="text-xl  text-right mb-4 ">
          {formatDate(userData.exam_completion_date)}
        </h1>

        {/* Content here spans across multiple pages */}
        <p className="text-slate-700 ">
          Agreement of Appointment and engagement, by EFFICIENT Insurance
          Brokers Pvt. Ltd. , for implementation of IRDAI guidelines/ circular
          no. IRDA/Int/GDL/ORD/183/10/2015 dated 26 th of October 2015, followed
          by IRDAI circular; IRDA/Int/GDL/ORD/047/03/2016 dated 11th March 2016
          (amended from time to time) and consequential compliance obligations
          of the Point of Sales (POS) Person vis-àvis-{' '}
          <span className="font-bold">
            {userData.first_name +
              ' ' +
              userData.middle_name +
              `${userData.middle_name ? ' ' : ''}` +
              userData.last_name}
          </span>
        </p>
        <p className="text-slate-700 mt-2">
          This Agreement <span>{'("Agreement")'}</span> dated{' '}
          <span className="font-bold">
            {formatDate(userData.exam_completion_date)}
          </span>
          , between{' '}
          <span className="font-bold">
            {userData.first_name +
              ' ' +
              userData.middle_name +
              `${userData.middle_name ? ' ' : ''}` +
              userData.last_name}
          </span>{' '}
          (hereinafter referred to as “The POS) and EFFICIENT Insurance Brokers
          Pvt. Ltd. (hereinafter referred to as The Company ), sets forth the
          terms and conditions under which POS shall perform certain services
          for the Company. POS and Company may also be referred to individually
          as a “party” and together as the “parties.”
        </p>

        <p className="text-slate-700 mt-2">
          WHEREAS, Company is a direct Insurance Broker registered by IRDAI vide
          registration number 339valid w.e.f. 27/11/2018 to 26/11/2027 and
          renewable thereafter from time to time.
        </p>
        <p className="text-slate-700 mt-2">
          WHEREAS, the Company wishes to contract with POS to solicit the
          Insurance products, as may be specified by IRDAI from time to time, on
          the terms and conditions provided for herein.
        </p>
        <p className="text-slate-700 mt-2">
          WHEREAS, the POS desires to enter into an Agreement with Company for
          the solicitation of such Insurance product/products.
        </p>
        <p className="text-slate-700 mt-2">
          WHEREAS, The Company appoints the POS for the purpose of selling and
          servicing of Insurance policies on behalf of the Company,
        </p>
        <p className="text-slate-700 mt-2">
          The Company reserves the right to approve or disapprove the
          contracting of any such POS. The Company and the POS expressly agree
          that the POS is not an employee of the Company and shall be considered
          an independent contractor for the purposes of this agreement. The POS
          shall not be reimbursed for any expenses incurred under this agreement
          and shall supply his or her own work place, use his or her own
          supplies and set his or her own work hours, all at no cost to the
          Company.
        </p>
        <p className="text-slate-700 mt-2">
          NOW, THEREFORE, in consideration of the mutual promises and covenants
          herein stated, and for other good and valuable consideration, the
          parties hereto agree as follows:
        </p>

        <h1 className="text-lg font-bold mb-4 mt-2">1. APPOINTMENT</h1>

        <p className="text-slate-700 mt-2 ml-10">
          1.1. The Company hereby appoints POS to solicit, at its own expense,
          new and/or renewal applications for insurance contracts{' '}
          <span>{'("Policy" or "Policies")'}</span> as listed in Annexure 1, as
          amended from time to time. No product shall be solicited by the POS
          other than the list mentioned in Annexure 1.
        </p>

        <h1 className="text-lg font-bold mb-4 mt-2">2. DUTIES OF POS</h1>
        <p className="text-slate-700 mt-2 ml-10">
          2.1. The POS, in his capacity as POS, shall be responsible for
          assuring that all of its Producers, as well as the POS himself, comply
          with the following duties.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.2. POS will comply with all laws and regulations which relate to
          this Agreement and shall indemnify and hold the Company harmless for
          its failure to do so. POS shall maintain in good standing, at its own
          cost, licenses required by all applicable statutes and regulations.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.3. POS may not solicit any business except mentioned in Annexure 1
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.4. POS will comply with the <span>{"Company's"}</span> rules and
          regulations relating to the Soliciting the insurance business. As a
          material part of the consideration for the making of this Agreement by
          the Company, POS agrees that there will be made no representations
          whatsoever with respect to the nature or scope of the benefits of the
          Policies sold except through and by means of the written material
          either prepared and furnished to POS for that purpose by the Company
          or approved in writing by the Company prior to its use. POS shall have
          no authority and will not make any oral or written alteration,
          modification, or waiver of any of the terms or conditions of any
          Policy whatsoever.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.5. POS warrants that POS will diligently and to the best of its
          ability ensure that the facts set forth by any applicant/prospect in
          any application it solicits are true and correct.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.6. POS will conduct itself so as not to adversely affect the
          business, good standing, and reputation of the Company.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.7. POS agrees not to employ or make use of any advertisement in
          which the <span>{"Company's"}</span> (or its affiliates) name or its
          registered trademarks are employed without the prior written approval
          and consent of the Company. Upon request of POS during the term of
          this Agreement, the Company shall make available for{' '}
          <span>{"POS's"}</span> use, standard visiting cards and other
          material. POS may add, at <span>{"POS's"}</span> expense, to the
          standard advertising only its business name, business address, POS
          number and telephone number, as provided for in the advertising. No
          deletions or changes in the advertising copy are permissible.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          POS shall act solely as an independent contractor, of-course subject
          to the control and guidance of the company, and as such, shall have
          control on all matters, its time and effort in the placement of the
          Policies offered hereunder. Nothing herein contained shall be
          construed to create a relationship of employer and employee between
          the POS and the Company.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.8. POS shall indemnify and hold the Company and its officers,{' '}
          <span>{"POS's"}</span> and employees harmless from all expenses,
          costs, causes of action, claims, demands, liabilities and damages,
          including reasonable <span>{"attorney's"}</span> fees, resulting from
          or growing out of any unauthorized act or transaction or any negligent
          act, omission or transaction by POS or employees of POS.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.9. Solicitation of Applications. POS is authorized to solicit the
          Insurance Business mentioned in Annexure 1 and as per additional
          description and narration as may be advised by the company.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.10. No Prior Disciplinary or Criminal Proceedings. POS represents
          and warrants that he/she has never been convicted of any crime
          involving moral turpitude and is not disqualified as per section
          42D(5) of the Insurance Act and remains Fit and Proper as per the
          format enclosed herewith in Annexure 2 of this agreement.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.11. Change of Address. POS shall notify Company in writing of any
          change of address and/or communication at least thirty (30) days prior
          to the effective date of such change.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.12. POS shall not engage or employ anyone as canvassers or agents
          for soliciting the insurance business.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.13. Collection of Premiums. POS shall have no authority, without
          written permission of Company, to collect or provide receipt for
          premiums to customer and shall assist the client for compliance of
          section 64VB of the Insurance Act 1938.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.14. Other Expenses. POS shall have no claim or shall not be entitled
          to reimbursement for any expenses.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.15. POS shall, on behalf of the Company, collect premiums as per
          IRDAI norms. All premiums collected on business produced by the POS
          hereunder shall be submitted to the Company within the same day of
          receipt by POS.
        </p>

        <p className="text-slate-700 mt-2 ml-10">
          2.16. To faithfully perform all duties required hereunder, to
          cooperate with the Company in all matters pertaining to the issuance
          of policies, cancellations, claims and to promote the best interest of
          the Company.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.17. POS will be bound not to work for any other intermediaries or
          the Insurance companies. Whatever work he does in the insurance space,
          POS is bound to do through Company only.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.18. POS will ensure the compliance of FIU and obtain KYC.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          2.19. POS shall not do any claim consultancy and any such opportunity
          that comes in this area. He shall be further obliged to bring to the
          notice of the company for its further doing the needful in a
          professional manner.
        </p>
        <p className="text-slate-700 mt-3 ml-10">
          2.20. Any financial penalty levied by the IRDAI, if it is based on the
          violations and non compliance by the POS shall be borne by him.
          Similarly if suspension, cancellation or withdrawal of license of the
          company is based on breaches/non compliance on the account of POS, the
          POS shall indemnify the consequential losses to the company.
        </p>

        <p className="text-slate-700 mt-2 ml-10">
          2.21. The POS shall be duty bound to cooperate with the officers of
          IRDAI for the purpose of inspection as may be required by IRDAI
          inspectors or investigating authority from time to time.
        </p>
        <h1 className="text-lg font-bold mb-4 mt-2">
          3. DUTIES OF THE COMPANY
        </h1>
        <p className="text-slate-700 mt-2 ml-10">
          3.1. The duties of the Company shall vary depending upon the specific
          product being sold by POS. For all products, the Company will provide
          brochures and proposal forms. The Company will deliver to the customer
          all insurance policies and related correspondence or similar
          documents, in accordance with Company procedures. The Company shall
          respond in a reasonable and timely manner to inquiries and questions
          about the product. The Company shall maintain reasonable accounting,
          administrative, and statistical records in accordance with prudent
          standards of insurance record keeping, including premium, sale or
          effective date, and any other records needed to verify coverage, pay
          claims, or underwrite the company insurance products, of any insured
          participant covered under the policies.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          3.2. The Company shall provide administrative support including
          infrastructure to the POS to enable him to perform his obligation on
          the interest of Broking Company and the customer whose business has
          been solicited.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          3.3. The POS will get the renewal commission on the business solicited
          by him and the Company will never reach out to these policy holders
          for renewals.
        </p>
        <h1 className="text-lg font-bold mb-4 mt-2">
          4. RESERVATION OF RIGHTS
        </h1>

        <p className="text-slate-700 mt-2 ml-10">
          4.1. The Company reserves the right to reject any and all applications
          for its Policies submitted by POS if they are not found to be of the
          order of merit required by the customer or the company or the
          Insurance Company.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          4.2. The Company reserves the right to discontinue writing or offering
          any of the Policies which become subject to this Agreement upon sixty
          (60) days notice to POS (or the number of days required by law in the{' '}
          <span>{"POS's"}</span> state of domicile).
        </p>

        <h1 className="text-lg font-bold mb-4 mt-2">
          5. MAINTENANCE OF RECORDS
        </h1>

        <p className="text-slate-700 mt-2 ml-10">
          5.1. Company and POS each shall maintain records of transactions
          individually.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          5.2. The Company, its employees, or authorized representatives may
          have unrestricted access to records and may audit, inspect and examine
          at reasonable times, upon reasonable notice and during regular
          business hours at <span>{"POS's"}</span> place of business, all books
          and records,
        </p>

        <p className="text-slate-700 mt-3 ml-10">
          5.3. During the term of the Agreement, any extensions of it and for
          five (5) years thereafter, the Company shall keep strictly secret and
          confidential any Confidential Information about POS, and POS shall
          keep strictly secret and confidential any Confidential Information
          about the Company
        </p>

        <p className="text-slate-700 mt-2 ml-10">
          <span>{'"Confidential Information"'}</span> shall, amongst other
          necessary matter/s, include: information, written or unwritten, which
          pertains in any way to financial or accounting matters, business
          production, methods of business operations, marketing, strategic
          planning or proprietary information of any kind or nature whatsoever,
          including trade secrets or know-how.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          Confidential Information does not include information that:
        </p>
        <ul className="text-slate-700 mt-2 ml-20">
          <li>
            (i) is already known to the recipient at the time of disclosure to
            it
          </li>
          <li>
            (ii) is in the public domain or subsequently becomes publicly
            available
          </li>
          <li>
            (iii) is provided to the recipient by a third party who is under no
            such obligation of confidentiality
          </li>
          <li>(iv) is independently developed by the recipient.</li>
        </ul>
        <p className="text-slate-700 mt-2 ml-10">
          Each party shall take necessary and reasonable precautions to prevent
          unauthorized disclosure of confidential information and shall require
          all of its officers, employees, and other personnel to whom it is
          necessary to disclose the same, or to whom the same has been
          disclosed, to keep this confidential information secret and
          confidential. It is understood, however,that certain{' '}
          <span>{'"Confidential Information"'}</span> may be required to be
          filed with State and Central regulatory agencies in accordance with
          their reporting requirements. Neither party shall make use of the name
          or service mark(s) of the other, including use of the name or service
          mark(s) of any marketing, enrollment, or other public relations
          material without prior written approval of the other party.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          5.4. There shall be restrictions on use of the Company logo and
          letterhead by POS unless approved by the Company in writing.
        </p>
        <h1 className="text-lg font-bold mb-4 mt-2">6. COMPENSATION</h1>
        <p className="text-slate-700 mt-2 ml-10">
          6.1. Compensation for each policy written hereunder shall be made by
          the Company to POS in accordance with mutual agreement as amended from
          time to time.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          6.2. Compensation due under this Agreement shall be paid to POS within
          30 days from the end of each calendar quarter in which the Company
          receives premium with respect to its Policies or as may otherwise be
          agreed upon in writing.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          6.3. Under all circumstances, the Company shall have the right to
          offset overpayments to POS against amounts due to POS.
        </p>
        <h1 className="text-lg font-bold mb-4 mt-2">
          7. EFFECTIVE DATE, TERM AND TERMINATION
        </h1>
        <p className="text-slate-700 mt-2 ml-10">
          7.1. This Agreement shall commence on the effective date first stated
          above and shall continue in force until terminated pursuant to this
          Article. Upon termination, all business produced by the POS shall
          remain in full force and effect until the natural expiration or prior
          cancellation of such business, and shall be subject to all terms and
          conditions of this Agreement. Upon termination, all data related to
          policy holders will be handed over to the Company by POS.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          7.2. This Agreement will terminate automatically upon the occurrence
          of any of the following events by POS, and upon such occurrence the
          parties shall be obligated to make only those payments the right to
          which accrued to the date of termination:
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          7.2.1. Conviction of a felony by POS
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          7.2.2. Misappropriation (or failure to remit) any funds or property
          due the Company from POS
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          7.2.3. Determination that POS is not in compliance with Company
          underwriting guidelines or the terms of this Agreement and POS has
          failed to correct the problem within 10 days of the Company providing
          written notice of same;
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          7.2.4. In the event of fraud or material breach of any of the
          conditions or provisions of this Agreement on the part of either
          party, the other party may terminate the Agreement immediately upon
          written notice.
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          7.2.5. Fails to comply with directions of the Company.
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          7.2.6. Furnish wrong information or conceals the information or fails
          to disclose the material facts of the policy to the policy holder.
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          7.2.7. Fails to resolve complaints, unless the circumstances are
          beyond his control, emanating from the business procured by him and
          persons he deals with
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          7.2.8. Indulges in inducement in cash or kind with client or any other
          insurance intermediary/agent/insurer.
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          7.2.9. Fails to pay any penalty levied on his account.
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          7.2.10. Fails to carry out his obligations as prescribed in the
          agreement and in the provisions of Act/regulations/circulars or
          guidelines by IRDAI from time to time.
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          7.2.11. Acts in a manner prejudice to the interest of the company or
          the client
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          7.2.12. Acts in a manner that amounts to diverting funds of his
          Group/Affiliates or associates rather than engaging in the activity of
          soliciting and servicing insurance business
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          7.2.13. Is found guilty of fraud or is charged or convicted in any
          criminal act.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          7.3. In the event of a material breach by a party to this Agreement,
          the non-breaching party may terminate this Agreement after providing
          thirty (30) days written notice to the breaching party to cure such
          breach. Upon such occurrence, a party shall be obligated to make only
          those payments the right which accrued to the date of termination.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          7.4. The Company will not have any objection in the event, where POS
          wishes to end the relationship/contract with the Company. The Company
          will issue NOC and simultaneously terminate the agreement.
        </p>

        <h1 className="text-lg font-bold mb-4 mt-16">8. GENERAL PROVISIONS</h1>
        <p className="text-slate-700 mt-2 ml-10">
          8.1 Failure of either party to insist upon the performance of any of
          the terms of this Agreement or to declare a forfeiture or termination
          in the event of non-performance by the other party shall not
          constitute a waiver of performance required hereunder.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          8.2 No assignment, transfer or disposal of any interest that a party
          may have pursuant to this Agreement shall be made at any time without
          prior written approval of the other party. Notwithstanding the
          foregoing, Company may assign any and all interests under this
          Agreement to a parent or affiliate, or due to merger or acquisition
          without the consent of POS.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          8.3 This Agreement shall be binding upon the administrators and
          executors, successors and permitted assignees of the parties hereto.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          8.4 No Amendment or modification of this Agreement shall be valid, or
          of any force or effect, unless the same be in writing and acknowledged
          and signed by the Company and POS.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          8.5 Any disputes, claims or counterclaims arising from or relating to
          this Agreement shall be subject to the Jurisdiction of the courts in
          India with first preference exercised to resolve by Alternative
          dispute resolution Indian system.
        </p>
        <h1 className="text-lg font-bold mb-4 mt-2">
          9. INTELLECTUAL PROPERTY
        </h1>
        <p className="text-slate-700 mt-2 ml-10">
          9.1. The POS agrees, warrants and undertakes that it shall take steps
          to safeguard the <span>{"company's"}</span> intellectual property
          rights, if in its possession or the Company’s Products, Services and
          software are not infringed, passed off, diluted, reverse-engineered,
          hacked into, misappropriated, tampered with and/or copied by the POS,
          and/or its directors, officers, employees, agents, representatives,
          subsidiaries, associates, etc.
        </p>
        <h1 className="text-lg font-bold mb-4 mt-2">
          9. INTELLECTUAL PROPERTY
        </h1>
        <p className="text-slate-700 mt-2 ml-10">10. INDEMNITY</p>
        <p className="text-slate-700 mt-2 ml-10">
          10.1. The POS, shall at its own expense, indemnify, defend and hold
          harmless the Company and its officers, directors, employees and
          representatives, against any third party claim, demand, suit, action,
          or other proceeding brought against the Company or its officers,
          directors, employees and representatives and against all damages,
          awards, settlements, liabilities, losses, costs and expenses related
          thereto (including without limitation attorneys’ fees) to the extent
          that such claim suit, action or other proceedings is based on or
          arises from any deficiency in service, by the POS, as per the scope of
          work as detailed in Annexure 1 hereto or any other breach of terms of
          this Agreement.
        </p>
        <h1 className="text-lg font-bold mb-4 mt-16">
          11. COMPLIANCE WITH THE LAWS
        </h1>
        <p className="text-slate-700 mt-2 ml-10">
          11.1. Each party represents that it shall abide by and observe all
          applicable laws, rules, regulations.
        </p>
        <h1 className="text-lg font-bold mb-4 mt-2">
          12. GOVERNING LAW AND DISPUTE RESOLUTION
        </h1>
        <p className="text-slate-700 mt-2 ml-10">
          12.1. Any dispute, controversy or claims arising out of or relating to
          this Agreement or the breach, termination or invalidity thereof, shall
          be settled by arbitration in accordance with the provisions of the
          Arbitration and Conciliation Act, 1996. The Arbitral Tribunal shall
          compose of a sole arbitrator to be appointed by both the Parties in
          mutual consent. The place of arbitration shall be Mumbai and any award
          whether interim or final, shall be made, and shall be deemed for all
          purposes between the parties to be made, in Mumbai. The arbitral
          procedure shall be conducted in the English language and any award or
          awards shall be rendered in English. The provisions of this Agreement
          shall be governed by and construed in accordance with Indian law. Only
          the courts at Mumbai shall have exclusive jurisdiction in all matters
          arising under this Agreement
        </p>
        <h1 className="text-lg font-bold mb-4 mt-2">13. SEVERABILITY</h1>
        <p className="text-slate-700 mt-2 ml-10">
          13.1. If any provision of this Agreement is held illegal or
          unenforceable by any court or other authority of competent
          jurisdiction, such provision shall be deemed severable from the
          remaining provisions of this Agreement and shall not affect or impair
          the validity or enforceability of the remaining provision of this
          Agreement.
        </p>
        <h1 className="text-lg font-bold mb-4 mt-2">14. FORCE MAJEURE</h1>
        <p className="text-slate-700 mt-2 ml-10">
          14.1. Neither Party shall be under any liability for any failure to
          perform any of its obligations under this Agreement due to Force
          Majeure. For the purpose of this clause, “Force Majeure” means fire,
          explosion, flood, Act of God, act of terrorism, war, rebellion, riots,
          or sabotage or events or circumstances which are wholly outside the
          control of the party affected thereby. Where, such event continues to
          exist for a continuous period of 3 months or more, the Parties hereby
          agrees that the Agreement shall stand terminated.
        </p>
        <h1 className="text-lg font-bold mb-4 mt-2">
          15. TRAINING AND QUALIFICATION REQUIREMENTS FOR POS
        </h1>
        <p className="text-slate-700 mt-2 ml-10">
          15.1. The POS person shall be at least 10 th pass or attain any other
          qualification IRDAI may prescribe from time to time.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          15.2. He shall attend the mandated in-house training for POS (minimum
          15 hrs as per IRDA guideline), pass the examination and be certified
          as POS of the Company . The mode of training will be specified by the
          Company from time to time.
        </p>
        <p className="text-slate-700 mt-1 ml-10">
          15.3. Agreement will be executed only after completion of In-house
          training & obtaining certificate from the Company.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          15.4. All the expenses for training, if any, shall be borne by the
          Company.
        </p>

        <h1 className="text-lg font-bold mb-4 mt-2">16. CONFIDENTIALITY</h1>
        <p className="text-slate-700 mt-2 ml-10">
          16.1 Any information marked as confidential, if disclosed during the
          course of business by one Party to the other, shall be treated as the
          Party would treat its own confidential information.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          16.2 The Parties shall not disclose the terms of this Agreement or
          make any announcement in respect of the subject matter thereof without
          prior written consent of the other Party unless the disclosure is
          required by law or other regulatory authorities. In the event
          disclosure is required by law, rules or regulations, such disclosure
          shall be made (a) after the disclosing Party has taken reasonable
          steps to consult with the other Party as to the terms of the
          disclosure; (b) only to the extent necessary by such law, rule or
          regulation; and (c) only to the person or persons and in the manner
          required by law, rule or regulations or otherwise as agreed by the
          Parties.
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          16.3 It is agreed that obligations of the Parties under this Clause 16
          shall survive the termination of this Agreement.
        </p>
        <p className="text-slate-700 mt-8 ">
          This Agreement constitutes the entire Agreement between the parties
          with respect to its matter, IN WITNESS WHEREOF, intending to be
          legally bound hereby, the parties hereto have executed this Agreement.
        </p>
        <p className="text-slate-700 mt-16 ">
          For <b>EFFICIENT Insurance Brokers Pvt. Ltd.</b>
        </p>
        <p className="text-slate-700 mt-16 ">Authorised Person</p>
        <p className="text-slate-700 mt-4 ">
          Date: {formatDate(userData.exam_completion_date)}
        </p>
        <p className="text-slate-700 mt-4 ">
          POS Name:{' '}
          {userData.first_name +
            ' ' +
            userData.middle_name +
            `${userData.middle_name ? ' ' : ''}` +
            userData.last_name}
        </p>
        <p className="text-slate-700 mt-4 ">
          Address:{' '}
          {userData.address +
            `${userData.address_one ? ', ' : ''}` +
            userData.address_one +
            `${userData.address_two ? ', ' : ''}` +
            userData.address_two}
        </p>
        <p className="text-slate-700 mt-4 ">PAN CARD : {userData.pan_no}</p>
        <p className="text-slate-700 mt-4 ">
          AADHAR CARD NO : {userData.aadhaar_no}
        </p>
        <p className="text-slate-700 mt-4 ">
          Date of qualifying Exam : {formatDate(userData.exam_completion_date)}
        </p>
        <p className="text-slate-700 mt-2 ">Documents collected and Verified</p>
        <p className="text-slate-700 mt-2 ml-10">1. Pan Card Copy</p>
        <p className="text-slate-700 mt-2 ml-10">
          2. Address proof for communication address
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          3. Proof of educational qualification
        </p>
        <p className="text-slate-700 mt-2 ml-10">
          4. Bank details for credit of commission
        </p>

        <h1 className="text-lg text-center font-bold mb-4 mt-16 underline">
          ANNEXURE-2
        </h1>
        <p className="text-slate-700 mt-2 ">
          Duly completed by POS MR /Ms MANOJ POOJARI and accepted by authorised
          persons as part of the agreement of engagement of the POS by Broking
          Company.
        </p>
        <p className="text-slate-700 mt-2 ">
          Name of Insurance Broker: EFFICIENT Insurance Brokers Pvt. Ltd.
        </p>
        <p className="text-slate-700 mt-2 ml-10">I. Personal Details of POS</p>
        <p className="text-slate-700 mt-2 ml-20">
          a. Full Name{' '}
          <span>
            {userData.first_name +
              ' ' +
              userData.middle_name +
              `${userData.middle_name ? ' ' : ''}` +
              userData.last_name}
          </span>
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          b. Position in the entity : POS
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          c. Date of Birth {userData.dob}
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          d. Educational Qualifications : {userData.qualification}
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          e. Relevant Background and Experience
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          f. Permanent Address :{' '}
          {userData.address +
            `${userData.address_one ? ', ' : ''}` +
            userData.address_one +
            `${userData.address_two ? ', ' : ''}` +
            userData.address_two}
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          g. Present Address :{' '}
          {userData.residence_address +
            `${userData.residence_address_one ? ', ' : ''}` +
            userData.residence_address_one +
            `${userData.residence_address_two ? ', ' : ''}` +
            userData.residence_address_two}
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          h. E-mail Address : {userData.email}
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          i. Telephone Number : {userData.mobile_no}
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          j. PAN under the Income Tax Act {userData.pan_no}
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          k. Relevant knowledge and experience in Insurance
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          l. Any other information relevant to position
        </p>
        <p className="text-slate-700 mt-2 ml-20">
          <Checkbox checked>
            All the above information are true and correct
          </Checkbox>
        </p>
        <p className="text-slate-700 mt-2 ml-10">II.</p>

        <Questions answers={answers} setAnswers={setAnswers} />

        <p className="text-slate-700 mt-2 ml-10">
          III. Any other explanation / information in regard to items I and II
          and other information considered relevant for judging fit and proper
          Undertaking I confirm that the above information is, to the best of my
          knowledge and belief, true and complete. Undertake to keep the
          Authority fully informed, as soon as possible, of all events, which
          take place subsequent to my appointment, which are relevant to the
          information provided above.
        </p>

        <p className="text-slate-700 mt-16 ">Place: Mumbai</p>
        <p className="text-slate-700 mt-4 ">
          Date: {formatDate(userData.exam_completion_date)}
        </p>
        <p className="text-slate-700 mt-4 ">
          Name of The POS:{' '}
          {userData.first_name +
            ' ' +
            userData.middle_name +
            `${userData.middle_name ? ' ' : ''}` +
            userData.last_name}
        </p>
        <p className="text-slate-700 mt-28 mb-4 ">
          Counter signature of the acceptance of the above by the authorised
          person of the Broking Company
        </p>
        <p>Authorized Signatory</p>
        <img src={signature} alt="signature" className="h-20 " />
        <p className="text-md font-bold">Mr. Prasad Shinde</p>
        <p className="text-md ">Principal Officer</p>

        <p className="text-sm text-gray-500 font-bold">
          EFFICIENT Insurance Brokers Pvt. Ltd.
        </p>
        <p className="text-slate-700 mt-4 ">
          Place: <span className="font-bold">Mumbai</span>
        </p>
        <p className="text-slate-700 mt-4 ">
          Date:{' '}
          <span className="font-bold">
            {formatDate(userData.exam_completion_date)}
          </span>
        </p>
      </div>

      {/* Buttons */}
      <div className="mt-6 flex space-x-4">
        <Button
          className="px-6 py-2 bg-blue-600 text-white rounded-lg shadow font-bold"
          onClick={() => handleGeneratePDF()}
          disabled={Object.values(answers).includes('yes')} // Disable if any answer is "yes"
        >
          {loading ? 'Sending...' : 'Submit'}
        </Button>
      </div>
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg">
            <p className="text-xl font-semibold text-gray-800">🚀 Sending...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AgreementPage;
